import { render, staticRenderFns } from "./AccidentClientForm.vue?vue&type=template&id=e1099a9a&scoped=true"
import script from "./AccidentClientForm.vue?vue&type=script&lang=js"
export * from "./AccidentClientForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1099a9a",
  null
  
)

export default component.exports